<template>
    <DatePicker
        v-if="shouldShow"
        v-model="line.invoiceDueDate"
        size="sm"
        placeholder="Forfallsdato"
        date-format="dd.MM.yy"
        :year-color-hint="false"
    />
    <div v-else/>
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import DatePicker from '@/dateUtils/DatePicker.vue'
import {computed} from 'vue'
import {findSubAccountByUuid} from '@/subaccount/subAccount.service'

// TODO should also show when registering a customer invoice and maybe when registering payment
const line = defineModel<TransactionEntryLine>({required: true})

const isSubAccount = (subAccountUuid: string | undefined) => {
    return subAccountUuid && findSubAccountByUuid(subAccountUuid)
}

const shouldShow = computed(() => {
    return isSubAccount(line.value.creditSubAccount) || isSubAccount(line.value.debitSubAccount)
})

</script>

<style scoped>

</style>